import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#0A1929] text-white mt-auto">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo og beskrivelse */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
                <span className="text-[#0A1929] font-bold text-lg">M</span>
              </div>
              <span className="font-heading font-bold text-xl">Minitask</span>
            </div>
            <p className="text-white/70 text-sm">
              Finn lokale oppdrag og småjobber i ditt nærområde. 
              Koble sammen de som trenger hjelp med de som vil jobbe.
            </p>
          </div>

          {/* Lenker */}
          <div>
            <h3 className="font-heading font-semibold mb-4">Lenker</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-white/70 hover:text-white transition-colors">
                  Finn oppdrag
                </Link>
              </li>
              <li>
                <Link to="/opprett-annonse" className="text-white/70 hover:text-white transition-colors">
                  Legg ut oppdrag
                </Link>
              </li>
              <li>
                <Link to="/personvern" className="text-white/70 hover:text-white transition-colors">
                  Personvernerklæring
                </Link>
              </li>
            </ul>
          </div>

          {/* Kontakt */}
          <div>
            <h3 className="font-heading font-semibold mb-4">Kontakt</h3>
            <ul className="space-y-2 text-sm text-white/70">
              <li className="flex items-center gap-2">
                <span className="material-symbols-outlined text-lg">email</span>
                kontakt@minitask.no
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-8 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/50 text-sm">
              © {new Date().getFullYear()} Minitask. Alle rettigheter reservert.
            </p>
            <div className="flex items-center gap-2 text-sm text-white/50">
              <span>Nettside designet og levert av</span>
              <a 
                href="https://designblokk.no" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-1 hover:text-white transition-colors"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" 
                        stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span className="font-medium">Designblokk</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
